import React from "react";
import {
  TestimonialsContainer,
  TestimonialsHeading,
  TestimonialCarousal,
  LeftArrow,
  TestimonialImage,
  RightArrow,
} from "./styles";
import { TestimonialsList } from "./config";
import LeftArrowSVG from "../../../../resources/left-arrow.svg";
import RightArrowSVG from "../../../../resources/right-arrow.svg";
import { isMobile } from "../../../../utils/common";

function Testimonials() {
  const [currentImage, setCurrentImage] = React.useState(0);
  return (
    <TestimonialsContainer>
      <TestimonialsHeading>What our users are saying.</TestimonialsHeading>
      <TestimonialCarousal>
        {!isMobile() && (
          <LeftArrow
            src={LeftArrowSVG}
            onClick={() => {
              if (currentImage === 0) {
                setCurrentImage(TestimonialsList.length - 1);
              } else {
                setCurrentImage(currentImage - 1);
              }
            }}
          />
        )}
        {TestimonialsList.map((testimonialImage, index) => {
          let visibilityState =
            currentImage === index ? 0 : currentImage < index ? 1 : -1;
          return (
            <TestimonialImage
              src={testimonialImage}
              visibilityState={visibilityState}
            />
          );
        })}
        {!isMobile() && (
          <RightArrow
            src={RightArrowSVG}
            onClick={() => {
              if (currentImage === TestimonialsList.length - 1) {
                setCurrentImage(0);
              } else {
                setCurrentImage(currentImage + 1);
              }
            }}
          />
        )}
      </TestimonialCarousal>
    </TestimonialsContainer>
  );
}
export default Testimonials;
